// extracted by mini-css-extract-plugin
export default {"container":"ForgotPasswordStepFour_container__ZvTTX","wrapperText":"ForgotPasswordStepFour_wrapperText__mpZuL"};